module.exports = "<div #d3GroupedBarChartRef></div>\r\n\r\n<!-- <p>d3gropuedchart works</p> -->\r\n"